<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "TraceReportLayout"
    }
</script>

<style scoped>

</style>
